<input
  #nativeInput
  [ngClass]="class"
  [type]="type"
  [name]="name"
  [placeholder]="placeholder"
  [value]="value"
  [attr.autocomplete]="getAutocomplete()"
  [required]="required"
  [disabled]="disabled"
  [class.input-inpage]="inpage"
  [class.error]="hasError"
  [(ngModel)]="inputValue"
  (ngModelChange)="inputChange(inputValue)"
/>
<span
  [ngClass]="{
    'underline-primary': type === InputType.Search,
    hidden: type !== InputType.Search,
  }"
></span>
